import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";

export default function TrainerAssignmentDeleteDialog({
  trainingTitle,
  entryDateLabel,
  isDeleting,
  isOpen,
  isRegular,
  onClose,
  onDelete,
}) {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        {isRegular ? "Regelmäßiges Training löschen" : "Training löschen"}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          <Typography variant="body2">
            Möchtest du <strong>{trainingTitle || "dieses Training"}</strong>
            {entryDateLabel ? ` am ${entryDateLabel}` : ""} wirklich löschen?
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {isRegular
              ? "Wähle aus, ob nur dieser Termin, dieser und alle folgenden oder die gesamte Serie entfernt werden soll."
              : "Dieser einzelne Termin wird entfernt."}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          pb: 3,
          pt: 0,
          flexDirection: "column",
          alignItems: "stretch",
          gap: 1,
          "& > :not(:first-of-type)": { ml: 0 },
        }}
      >
        {isRegular ? (
          <>
            <Button
              color="error"
              variant="outlined"
              onClick={() => onDelete({ deleteScope: "this" })}
              disabled={isDeleting}
              fullWidth
            >
              Nur diesen Termin löschen
            </Button>
            <Button
              color="error"
              variant="outlined"
              onClick={() => onDelete({ deleteScope: "thisAndFollowing" })}
              disabled={isDeleting}
              fullWidth
            >
              Diesen und alle folgenden löschen
            </Button>
            <Button
              color="error"
              variant="contained"
              onClick={() => onDelete({ deleteScope: "all" })}
              disabled={isDeleting}
              fullWidth
            >
              Gesamte Serie löschen
            </Button>
          </>
        ) : (
          <Button
            color="error"
            variant="contained"
            onClick={() => onDelete()}
            disabled={isDeleting}
            fullWidth
          >
            Termin löschen
          </Button>
        )}
        <Button onClick={onClose} disabled={isDeleting} fullWidth>
          Abbrechen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
